import { Group, Title } from "@mantine/core";
import type * as React from "react";

/**
 * A page's title row (Figma "Header"): the title in 13px semibold on the left, and on the
 * right either a meta line (`text/secondary`, e.g. "Last saved") or the page's primary
 * action.
 */
export function PageHeader({ title, aside }: { title: React.ReactNode; aside?: React.ReactNode }) {
  return (
    <Group justify="space-between" wrap="wrap" mih={38} gap="sm">
      <Title order={1} fz="sm" fw={600} lh={1.25}>
        {title}
      </Title>
      {aside}
    </Group>
  );
}
